import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useInquiry } from "./context/InquiryContext";
import { INQUIRY_STATUSES } from "./data/mockData";
import { Button } from "./components/common/Button";
import { Card, CardHeader } from "./components/common/Card";
import { EmptyState } from "./components/common/EmptyState";
import { FieldBox } from "./components/common/FormInput";
import { Modal } from "./components/common/Modal";
import { FollowUpPanel } from "./components/inquiry/FollowUpPanel";
import { InquiryStatusBadge } from "./components/inquiry/InquiryStatusBadge";
import { PriorityBadge } from "./components/inquiry/PriorityBadge";
import {
  useHistory,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import {
  deleteInquiry,
  editInquiry,
  getInquiryDetail,
} from "../../services/InqairyService";
import AddEditInquiryModal from "./Inquirymodal";
import { getEmployees } from "../../services/employeeService";
import { toastAlert } from "../../helpers/toastAlert";
import { INQUIRY_TYPE_OPTIONS } from "../../utils/fieldsConfig";
import { FALLBACK_INQUIRY_STATUS } from "../../utils/masterFallbacks";
import ModuleFollowups from "../CommonComponents/ModuleFollowups";
import AttachmentPanel from "../CommonComponents/AttachmentPanel";
import ConvertInquiryDrawer from "../CommonComponents/ConvertInquiryDrawer";
import { useMasters, masterLabel } from "../../hooks/useMasters";
import { convertInquiry } from "../../services/InqairyService";
import {
  canConvertInquiry,
  pipelineForInquiryType,
} from "../../utils/inquiryWorkstream";

function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-IN", {
      dateStyle: "long",
      timeStyle: "short",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

const InquiryDetail = (props) => {
  const { id } = useParams();
  const navigate = useHistory();
  const {
    getInquiryById,
    employees,
    updateInquiryStatus,
    convertToCustomer,
    busy,
  } = useInquiry();
  // const inquiry = getInquiryById(id)
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [banner, setBanner] = useState(null);
  const [convertOpen, setConvertOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const typeOptions = useMasters("inquiry_type", INQUIRY_TYPE_OPTIONS);
  const statusOptions = useMasters("inquiry_status", FALLBACK_INQUIRY_STATUS);

  const getEmployeeList = async () => {
    const employees = await getEmployees(props, 1, 100000000);
    if (employees?.data?.employees) setEmployeeData(employees?.data?.employees);
  };
  useEffect(() => {
    getEmployeeList();
  }, []);
  const [inquiry, setInquiry] = useState(null);
  const [loadingInquiry, setLoadingInquiry] = useState(true);
  const [savingConvert, setSavingConvert] = useState(false);
  const Fetchdetails = async () => {
    setLoadingInquiry(true);
    const res = await getInquiryDetail(id, props);
    if (res?.data?._id) {
      setInquiry(res.data);
    } else {
      setInquiry(null);
    }
    setLoadingInquiry(false);
  };
  useEffect(() => {
    Fetchdetails();
  }, [id]);
  if (loadingInquiry) {
    return (
      <div className="py-16 text-center text-sm text-slate-500">Loading inquiry…</div>
    );
  }
  if (!inquiry?._id) {
    return (
      <EmptyState
        title="Inquiry not found"
        description="It may have been removed or the link is invalid."
        actionLabel="Back to list"
        onAction={() => navigate.push("/inquiary")}
      />
    );
  }

  const isConverted = Boolean(inquiry.convertedTo || inquiry.status === "converted");

  const handleConvertSubmit = async (body) => {
    try {
      setSavingConvert(true);
      const res = await convertInquiry(props, inquiry._id, body);
      if (res?.code === 200 && res?.data) {
        const password = res.data.generatedPassword;
        toastAlert(res.message || "Converted successfully", "success");
        setBanner(
          password
            ? { type: "ok", text: `Customer portal password: ${password}` }
            : { type: "ok", text: "Inquiry converted. Open the linked file from the next-step card." }
        );
        setConvertOpen(false);
        Fetchdetails();
      } else {
        toastAlert(res?.message || "Conversion failed", "error");
      }
    } catch (err) {
      toastAlert("Conversion failed", "error");
      console.error(err);
    } finally {
      setSavingConvert(false);
    }
  };
  const handleDelete = async () => {
    const res = await deleteInquiry(inquiry._id, props);
    if (res?.status) {
      toastAlert(res?.data?.message || "Inquiry Deleted ", "success");
      setDeleteOpen(false);
      navigate.push("/inquiary");
    } else {
      toastAlert("Failed", "error");
    }
  };

  return (
    <div>
      {banner && (
        <div
          className={`mb-4 rounded-xl border px-4 py-3 text-sm ${
            banner.type === "ok"
              ? "border-emerald-200 bg-emerald-50 text-emerald-900"
              : "border-slate-200 bg-white text-slate-700"
          }`}
        >
          {banner.text}
        </div>
      )}

      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="text-sm text-slate-500 mb-1">Inquiries / Inquiry</div>
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-2xl font-extrabold text-slate-900 mb-0">
              Inquiry details
            </h1>
            <span className="rounded-full bg-[#e8eef8] px-3 py-1 text-xs font-bold text-[#1a3366]">
              {masterLabel(statusOptions, inquiry.status) || inquiry.status || "In progress"}
            </span>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button variant="secondary" size="sm" onClick={() => navigate.push("/inquiary")}>Back</Button>
          {canConvertInquiry(inquiry, props?.authData?.role) && (
            <Button size="sm" disabled={busy || savingConvert} onClick={() => setConvertOpen(true)}>
              {pipelineForInquiryType(inquiry.type) === "payment_recovery"
                ? "Start recovery file"
                : pipelineForInquiryType(inquiry.type) === "gst"
                  ? "Start GST case"
                  : "Convert to customer"}
            </Button>
          )}
          {!isConverted && (
            <Button variant="danger" size="sm" disabled={busy} onClick={() => setDeleteOpen(true)}>Reject</Button>
          )}
          {!isConverted && (
            <Button variant="secondary" size="sm" onClick={() => setEditOpen(true)}>Edit</Button>
          )}
        </div>
      </div>

      <div className="assign-banner">
        {pipelineForInquiryType(inquiry.type) === "payment_recovery"
          ? "Payment recovery flow — this inquiry converts to a customer and a recovery file. GST users cannot run this conversion."
          : pipelineForInquiryType(inquiry.type) === "gst"
            ? "GST flow — this inquiry converts to a customer and a GST case. Payment recovery users cannot run this conversion."
            : "Follow-ups stay on this inquiry until it is converted to a customer."}
      </div>

      <div className="mt-2 grid gap-4 lg:grid-cols-3">
        <div className="lg:col-span-2 space-y-3">
          <Card>
            <CardHeader title={inquiry.name} subtitle={masterLabel(typeOptions, inquiry.type) || "General"} />
            <div className="grid gap-2 sm:grid-cols-3">
              <FieldBox label="Mobile" required>{inquiry.mobile}</FieldBox>
              <FieldBox label="Service">{inquiry.service}</FieldBox>
              <FieldBox label="Source">{inquiry.source}</FieldBox>
              <FieldBox label="Priority">{inquiry.priority}</FieldBox>
              <FieldBox label="Status">{masterLabel(statusOptions, inquiry.status) || inquiry.status}</FieldBox>
              <FieldBox label="Assigned to">{inquiry.assignedTo?.name || "Unassigned"}</FieldBox>
              {inquiry.customer?.companyName ? (
                <FieldBox label="Customer">{inquiry.customer.companyName}</FieldBox>
              ) : null}
              <FieldBox label="Created">{formatDate(inquiry.createdAt)}</FieldBox>
            </div>
            {inquiry.notes && (
              <div className="mt-3">
                <FieldBox label="Notes">{inquiry.notes}</FieldBox>
              </div>
            )}
          </Card>
          {inquiry._id && (
            <Card>
              <CardHeader title="Module notes" subtitle="Extra trail for this inquiry" />
              <ModuleFollowups moduleName="inquiry" recordId={inquiry._id} props={props} />
            </Card>
          )}
          {inquiry._id && (
            <Card>
              <CardHeader title="Attachments" subtitle="Notices, KYC, and related files" />
              <AttachmentPanel moduleName="inquiry" recordId={inquiry._id} />
            </Card>
          )}
        </div>
        <div>
          <FollowUpPanel
            inquiryId={inquiry._id}
            variant="inline"
            props={props}
            contactName={inquiry.name}
            phone={inquiry.mobile}
          />
          <div className="mt-4">
            <Card>
              <CardHeader
                title={inquiry.convertedTo ? "Linked records" : "Next step"}
                subtitle={
                  inquiry.convertedTo
                    ? "This inquiry is already converted"
                    : pipelineForInquiryType(inquiry.type) === "payment_recovery"
                      ? "Creates customer + recovery file"
                      : pipelineForInquiryType(inquiry.type) === "gst"
                        ? "Creates customer + GST case"
                        : "Creates a customer record"
                }
              />
              <div className="flex flex-col gap-2">
                {inquiry.convertedTo ? (
                  <>
                    {inquiry.customer?.companyName || inquiry.customer?.name ? (
                      <Button
                        className="w-full"
                        size="sm"
                        onClick={() =>
                          navigate.push(
                            inquiry.customer?._id || inquiry.customerId
                              ? `/customers/${inquiry.customer?._id || inquiry.customerId}`
                              : "/customers"
                          )
                        }
                      >
                        Open customer · {inquiry.customer.companyName || inquiry.customer.name}
                      </Button>
                    ) : null}
                    {inquiry.convertedTo === "payment_recovery" && (
                      <Button
                        className="w-full"
                        size="sm"
                        onClick={() =>
                          navigate.push(
                            inquiry.convertedRecordId
                              ? `/payment?id=${inquiry.convertedRecordId}`
                              : "/payment"
                          )
                        }
                      >
                        Open recovery file
                      </Button>
                    )}
                    {inquiry.convertedTo === "gst" && (
                      <Button
                        className="w-full"
                        size="sm"
                        onClick={() =>
                          navigate.push(
                            inquiry.convertedRecordId
                              ? `/casemanagement?id=${inquiry.convertedRecordId}`
                              : "/casemanagement"
                          )
                        }
                      >
                        Open GST case
                      </Button>
                    )}
                  </>
                ) : (
                  <>
                    {canConvertInquiry(inquiry, props?.authData?.role) ? (
                      <Button className="w-full" size="sm" onClick={() => setConvertOpen(true)}>
                        {pipelineForInquiryType(inquiry.type) === "payment_recovery"
                          ? "Start recovery file"
                          : pipelineForInquiryType(inquiry.type) === "gst"
                            ? "Start GST case"
                            : "Convert to customer"}
                      </Button>
                    ) : (
                      <p className="text-sm text-slate-500 m-0">
                        Your role cannot convert this workstream. A payment recovery or GST user needs to continue.
                      </p>
                    )}
                    {inquiry.type === "task" && (
                      <Button className="w-full" variant="secondary" size="sm" onClick={() => navigate.push("/tasks")}>
                        Open Tasks
                      </Button>
                    )}
                  </>
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>

      <Modal
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        title="Delete inquiry?"
        footer={
          <>
            <Button variant="secondary" onClick={() => setDeleteOpen(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDelete} disabled={busy}>
              {busy ? "Deleting…" : "Delete"}
            </Button>
          </>
        }
      >
        <p className="text-sm text-slate-600">
          This removes <strong>{inquiry.name}</strong> and all follow-ups from
          this demo dataset. This action cannot be undone in the browser
          session.
        </p>
      </Modal>
      <AddEditInquiryModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        editData={inquiry}
        employeeData={employeeData}
        onSubmit={async (data) => {
          await editInquiry(props, data, inquiry._id);
          setEditOpen(false);
          Fetchdetails();
        }}
        props={props}
      />
      <ConvertInquiryDrawer
        open={convertOpen}
        onClose={() => setConvertOpen(false)}
        inquiry={inquiry}
        employeeData={employeeData}
        props={props}
        onSubmit={handleConvertSubmit}
        busy={savingConvert}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({ authData: state.authReducer });
export default withRouter(connect(mapStateToProps)(InquiryDetail));
